import React, { useState, useEffect } from 'react';
import Menu from '../../Menu';
import LoginHeader from '../../Login_header';
import { Container, Row, Col, Form, Button, Table } from 'react-bootstrap';
import * as Picklist from "./../../Picklist";
import AsyncSelect from 'react-select/async';
import { useNavigate } from 'react-router-dom';
import * as Common from "./../../Common";
import Dialog from './../../Dialog';
import DialogYesNo from './../../Dialog_Yes_No';
import $ from "jquery";

const Tran_knockoff_view = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [knockoffData, setKnockoffData] = useState([]);
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [knockoffLocation, setKnockoffLocation] = useState(null);
    const [knockoffType, setKnockoffType] = useState('');
    const [knockoffTypeOptions, setKnockoffTypeOptions] = useState([]);
    const [knockoffSrno, setKnockoffSrno] = useState('');
    const [location, setLocation] = useState('');

    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setKnockoffLocation(response);
            response != null && handleKnockoffLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_KNOCKOFF_VIEW'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });


    }, []);


    const handleKnockoffLocationChange = (value) => {
        setKnockoffLocation(value);
        const loc = value.id.split('^');
        setLocation(loc[1]);

        Common.callApi(Common.apiKnockoffView, [sid, "listKnockoffTypeList", loc[1]], result => {
            setKnockoffTypeOptions(JSON.parse(result));
        });
    }


    const knockoffList = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (knockoffLocation === null || knockoffSrno === "" || knockoffType == "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (knockoffLocation === null ? "Select Location." : '');
            msg[i++] = (knockoffSrno === "" ? "Srno." : '');
            msg[i++] = (knockoffType === "" ? "Type." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: location,
                knockoffType: knockoffType,
                knockoffSrno: knockoffSrno,
            }
            Common.callApi(Common.apiKnockoffView, [sid, "listKnockoffView", JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setKnockoffData(resp);
            });
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Transaction Knockoff View</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={knockoffLocation}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleKnockoffLocationChange}
                                isDisabled={branchDisable === "true"}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Label>Knockoff Type<span className="colorThemeRed">*</span></Form.Label>
                        <Form.Select
                            value={knockoffType}
                            onChange={(e) => {
                                setKnockoffType(e.target.value);
                            }}>
                            <option value="">Select</option>
                            {
                                knockoffTypeOptions.map((item, index) => (
                                    <option value={item.tfd_knockoff_type} key={index}>{item.tfd_knockoff_type}</option>
                                ))
                            }
                        </Form.Select>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Control type='text' maxLength={10} value={knockoffSrno} onChange={e => Common.validateNumValue(e.target.value, setKnockoffSrno)} />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        {
                            userRight.query == "1" &&
                            <Button style={{ marginTop: '33px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={knockoffList}> List</Button>
                        }
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Table responsive bordered striped>
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Srno</th>
                                <th>Type</th>
                                <th>Location</th>
                                <th>Date</th>
                                <th>Client</th>
                                <th>Party</th>
                                <th>Amount</th>
                                <th>Reference Type</th>
                                <th>Reference Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                knockoffData.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {/* <span onClick={() => deleteProduct(item.uniquekey, item.prd_vtm_num, item.prd_product)} className='colorThemeBlue pointer'>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </span> */}
                                        </td>
                                        <td>{item.tfd_srno}</td>
                                        <td>{item.tfd_type}</td>
                                        <td>{item.hdrlocation}</td>
                                        <td>{item.tfd_date}</td>
                                        <td>{item.hdr_individual > 0 ? item.hdr_individual + " " + item.ind_name : ""}</td>
                                        <td>{item.hdr_ledger > 0 ? item.hdr_group + " " + item.hdr_ledger + " " + item.mvli_ledger_name : ""}</td>
                                        <td>{item.tfd_amount}</td>
                                        <td>{item.tfd_reftype}</td>
                                        <td>{item.tfd_refnumber}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </>
    )
}

export default Tran_knockoff_view
